import { render, staticRenderFns } from "./double-bounce-spinner.vue?vue&type=template&id=477bc286"
import script from "./double-bounce-spinner.vue?vue&type=script&lang=js"
export * from "./double-bounce-spinner.vue?vue&type=script&lang=js"
import style0 from "./double-bounce-spinner.vue?vue&type=style&index=0&id=477bc286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../Shield.UI.ProductManagementSystemWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports